<template>
	<div>
		<section id="classes-list" class="pt-4 pb-5">
			<div class="container">

				<div class="row justify-content-center">
					<div class="col-xl-10 col-xxl-8 text-center">
						<p class="text-green-dark bold fs-1-3">
							<i>SEZIONE CONCORSO</i>
						</p>
						<h2 class="fs-2-7">Invia qui le foto per partecipare</h2>
						<p>
							Usa questa sezione per vedere le classi che hai inserito e aggiungere altre classi con cui partecipare. 
							Inviando le <strong>foto testimonianze e/o le foto del “Manifesto <i>Stammi Bene!</i>”</strong> partecipi all’assegnazione 
							dei premi per la tua scuola. Ricorda: <strong>più foto invii, più aumenti le vostre possibilità di vincere</strong>.
						</p>
					</div>
				</div>

				<div class="row justify-content-center" v-if="Object.keys(classesData).length">
					<div class="col-xxl-10">
						<div class="bg-secondary py-4 px-3" style="border-radius: 50px;">
							<div class="row justify-content-center" :class="{'no-click-element': !parseInt(checkKit)}">
								<div class="col-11 col-sm-6 col-lg-4 col-xl-3 text-center px-3 px-md-4 my-3" v-for="(item, index) in classesData.active_classes" :key="index">
									<div class="classes-item-sup p-3 bold fs-1-5 text-white">
										{{item.classe != '' && item.classe != 0 ? item.classe + ' ' : ''}}{{item.sezione}}
									</div>
									<div class="classes-item-sub">
										<button class="btn btn-green btn-lg rounded-pill d-inline-block w-100 mx-0 mt-0 mb-3 fs-1 border-end-0 border-start-0" style="margin-bottom:-4px;" @click.prevent="showSingleClassPage(item.id, item.classe, item.sezione)">
											<span>CARICA CONTRIBUTI</span> 
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<section id="add-class" class="pt-5 pb-5">
					<add-class-component
						:schoolType="schoolType"
						:check-kit="checkKit"
						@on-added-class="getClassesData"
					></add-class-component>
				</section>

			</div>
		</section>

	</div>
</template>

<script>
import axios from 'axios'
import AddClassComponent from './AddClassComponent.vue'

export default {
    props: ['idTeacher', 'schoolType', 'themaUrl', 'checkKit'],
	components:{AddClassComponent},

    data() {
        return {
            ajaxObj: window.ajax_object,
			siteUrl: this.themaUrl.replace('wp-content/themes/nl', ''),
            classesData: {},
            newClass: {
                classe: '',
                sezione: ''
            }
        }
    },

	methods: {
		getClassesData() {
			let url = this.ajaxObj.ajax_url
			axios.get(url,
			{
				params: {
					_nounce_value: this.ajaxObj._nounce_value,
					action: 'nl_get_classes_list',
					idTeacher: this.idTeacher,
					workType: 'primary'
				}
			})
			.then((response) => {
				this.classesData = response.data.classesData
				// console.log(response.data)
			})
			.catch((err) => {
				console.log(err)
			})
		},

		showSingleClassPage(id, classe, sezione) {
			this.$emit('editSingleClass', id, classe, sezione)
		}
    },

	mounted() {
		this.getClassesData()
		// window.scrollTo(0,0);
		// this.newClass.classe = this.schoolType == 'i' ? '0' : ''
	}
}
</script>